import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { ROUTES } from './InvoiceView.config';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../components/MainLayout';
import { PagesHeader } from '../../components/shared/PagesHeader';
import styles from './InvoiceView.styles.scss';
import Dashboard from './pages/Dashboard/Dashboard';
import Statement from './pages/Statement/Statement';
import { InvoiceList } from '.';
import { useAuthentication } from '../../hooks/useAuthentication';
import { PERMISSIONS } from '../../helpers/auth';

const InvoiceViewContainer = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [routes, setRoutes] = useState(ROUTES());

  const { t } = useTranslation();
  const { hasRole } = useAuthentication();

  const handleTabChange = (index) => {
    setActiveTab(index);
    setRoutes(ROUTES(index));
  };

  return (
    <MainLayout eInvoicing={true}>
      <PagesHeader
        withBreadcrumb={true}
        routes={routes}
        wrapperClassName={'mb-0'}
        withActionButton={true}
      />
      <TabView
        activeIndex={activeTab}
        onTabChange={(e) => handleTabChange(e.index)}
        className={styles.invoiceTabs}
        renderActiveOnly={false}
      >
        <TabPanel
          disabled={!hasRole(PERMISSIONS.VIEW_DASHBOARD)}
          header={t('invoice_list.dashboard')}
        >
          <Dashboard />
        </TabPanel>
        <TabPanel
          disabled={!hasRole(PERMISSIONS.VIEW_INVOICE_LIST)}
          header={t('invoice_list.invoice_list')}
        >
          <InvoiceList />
        </TabPanel>
        <TabPanel
          disabled={!hasRole(PERMISSIONS.VIEW_INVOICE_STATEMENT)}
          header={t('invoice_list.statement')}
        >
          <Statement />
        </TabPanel>
      </TabView>
    </MainLayout>
  );
};

export default React.memo(InvoiceViewContainer);
